// Inventory media is meant to be photos of the physical asset. Expenses also
// accept PDF invoices and videos, and those used to be copied into Inventory by
// the approval sync, which left rows whose only "photo" was a PDF.

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.heic', '.heif'];

// Strips any query string (S3 signed URLs) before looking at the extension.
export const isImageUrl = (url) => {
    if (!url) return false;
    const path = String(url).split('?')[0].toLowerCase();
    return IMAGE_EXTENSIONS.some(ext => path.endsWith(ext));
};

export const firstImageUrl = (urls) => (Array.isArray(urls) ? urls.find(isImageUrl) : undefined);

export const isImageFile = (file) =>
    !!file && (String(file.type).toLowerCase().startsWith('image/') || /\.(jpe?g|png|gif|webp|bmp|heic|heif)$/i.test(file.name || ''));

export { IMAGE_EXTENSIONS };
